@if(userType === 'LeapMotor'){
<mat-form-field class="{{displayClass}}">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  @if(iconClass){
    <mat-icon class="font-{{ size }} {{displayIconClass}}">{{ iconClass }}</mat-icon>
  }
  <mat-select
    [formControl]="formControl"
    (selectionChange)="onSelectionChange($event)"
    [disabled]="isDisabled"
    [compareWith]="compareWith"
    [panelClass]="panelClass"
  >
    <!-- Explicit trigger to avoid [object Object] -->
    <mat-select-trigger>
      <span>
        {{
          (formControl?.value?.[displayKey])
            || (optionType === 'primitive' ? formControl?.value : '')
        }}
      </span>
    </mat-select-trigger>

    @if(optionType != 'object') {
      <mat-option *ngFor="let option of options" [value]="option">
        {{ option }}
      </mat-option>
    } @else {
      <mat-option
        *ngFor="let option of options; trackBy: trackByKey ? trackByFunction : null"
        [value]="option"
      >
        {{ option[displayKey]}}
      </mat-option>
    }
  </mat-select>

  <mat-error *ngIf="formControl?.invalid">{{ errorMessage }}</mat-error>
</mat-form-field>
}
@else{
<mat-form-field appearance="outline" class="{{displayClass}}">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-select [formControl]="formControl" (selectionChange)="onSelectionChange($event)" [disabled]="isDisabled">
    @if(optionType != 'object') {
    <mat-option *ngFor="let option of options" [value]="option">
      {{ option }}
    </mat-option>
    } @else {
    <mat-option *ngFor="let option of options; trackBy: trackByKey ? trackByFunction : null" [value]="option">
      {{ option[displayKey] }}
    </mat-option>
    }
  </mat-select>
  <mat-error *ngIf="formControl?.invalid">{{ errorMessage }}</mat-error>
</mat-form-field>
}
